import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ValidationPinCode from "../../../components/ValidationPinCode";

import {
	phoneConfirmationRequest,
	resendPhoneConfirmationRequest,
	setPhoneConfirmationError,
	validateInitialOnboardingPhone,
} from "../../../store/modules/register/actions";

const ConfirmationCodePhone = (props) => {
	const { creationType, creationData } = props;

	const dispatch = useDispatch();

	const { initialOnboardingResponseData, validateInitialOnboardingResponse, phoneConfirmationError } =
		useSelector((state) => state.register);

	const [seconds, setSeconds] = useState(30);
	const [tokenRecaptcha, setTokenRecaptcha] = useState({});
	const [codeResendControl, setCodeResendControl] = useState({
		isResendCode: false,
		last: "",
	});

	const [error, setError] = useState(false);
	const [messageError, setMessageError] = useState("");

	useEffect(() => {
		if (
			validateInitialOnboardingResponse &&
			Object.keys(validateInitialOnboardingResponse).length &&
			codeResendControl.isResendCode
		) {
			setSeconds(validateInitialOnboardingResponse.seconds);
		}
	}, [validateInitialOnboardingResponse, codeResendControl]);

	useEffect(() => {
		setError(Boolean(phoneConfirmationError));
		setMessageError(phoneConfirmationError);
	}, [phoneConfirmationError]);

	useEffect(() => {
		const { isResendCode, last } = codeResendControl;

		if (isResendCode && Object.values(tokenRecaptcha).length && last.length) {
			const action = {
				phone_mobile: () => {
					dispatch(
						resendPhoneConfirmationRequest({
							cd_access_token:
								initialOnboardingResponseData.cd_access_token,
							vl_full_phone_number: creationData,
						})
					);
				},
				whatsapp: () => {
					dispatch(
						validateInitialOnboardingPhone({
							cd_access_token:
								initialOnboardingResponseData.cd_access_token,
							value: null,
							type: null,
							header: tokenRecaptcha,
						})
					);
				},
			};

			action[last]();

			setCodeResendControl({
				isResendCode: false,
				last: "",
			});
		}
	}, [tokenRecaptcha, codeResendControl]);

	const resendCode = useCallback((type) => {
		setCodeResendControl({
			isResendCode: true,
			last: type,
		});
	}, []);

	const submitCode = (pin) => {
		dispatch(
			phoneConfirmationRequest({
				cd_access_token: initialOnboardingResponseData.cd_access_token,
				verification: pin,
				vl_full_phone_number: creationData,
			})
		);
	};

	const onChange = () => {
		if (phoneConfirmationError.length) {
			setMessageError("");
			setError(false);
			dispatch(setPhoneConfirmationError(""));
		}
	};

	return (
		<ValidationPinCode
			title="Criar uma conta"
			subtitle="Para sua própria segurança, confirme seu <span style='color: var(--brand-primary);'>número de celular</span> para receber um código de verificação."
			resendType={creationType}
			seconds={seconds}
			onResendCode={resendCode}
			onSubmit={submitCode}
			setTokenRecaptcha={setTokenRecaptcha}
			error={error}
			messageError={messageError}
			onChange={onChange}
		/>
	);
};

export default ConfirmationCodePhone;
